import { Injectable } from "@angular/core";
import { lastValueFrom, Observable } from "rxjs";
import { DataResult, ICRUD } from '@phx-erp/shared';
import { BaseListService } from "../../../@core/services/base-list.service";
import { SystemService } from "../../../@core/services/system.service";
import { DELETE_DISCOUNT_GROUP_DOCUMENT_RELATION, GET_DISCOUNT_GROUP_DOCUMENT_RELATION, GET_DISCOUNT_GROUP_DOCUMENT_RELATIONS, SAVE_DISCOUNT_GROUP_DOCUMENT_RELATION } from "../../../data/definitions/discount-group-document-relation.definition";
import { QueryResult } from "../../../data/query-result";
import { BaseDataService } from "../../../data/services/base-data.service";
import { DeleteDiscountGroupDocumentRelationMutation, DeleteDiscountGroupDocumentRelationMutationVariables, DeletionResponse, DiscountGroupDocumentRelation, DiscountGroupDocumentRelationInput, DiscountGroupDocumentRelationSearchInput, GetDiscountGroupDocumentRelationQuery, GetDiscountGroupDocumentRelationQueryVariables, GetDiscountGroupDocumentRelationsQuery, GetDiscountGroupDocumentRelationsQueryVariables, SaveDiscountGroupDocumentRelationMutation, SaveDiscountGroupDocumentRelationMutationVariables } from "../../../generated/generated-types";

@Injectable({
    providedIn: 'root'
})
export class DiscountGroupDocumentRelationService extends BaseListService<DiscountGroupDocumentRelation> implements ICRUD<DiscountGroupDocumentRelation> {
    constructor(
        private baseDataService: BaseDataService,
        private systemService: SystemService,
    ) {
        super();
    }

    getData(searchInput?: DiscountGroupDocumentRelationSearchInput/*, options?: ICRUDOptions*/): Observable<DataResult<DiscountGroupDocumentRelation>> {
        return super.getData(searchInput);
    }

    getItems(searchInput: DiscountGroupDocumentRelationSearchInput): QueryResult<GetDiscountGroupDocumentRelationsQuery> {
        let fragment = GET_DISCOUNT_GROUP_DOCUMENT_RELATIONS;

        return this.baseDataService.query<GetDiscountGroupDocumentRelationsQuery, GetDiscountGroupDocumentRelationsQueryVariables>(
            fragment, {
            input: searchInput
        });
    }

    getItem(id: string): QueryResult<GetDiscountGroupDocumentRelationQuery> {
        return this.baseDataService.query<GetDiscountGroupDocumentRelationQuery, GetDiscountGroupDocumentRelationQueryVariables>(
            GET_DISCOUNT_GROUP_DOCUMENT_RELATION, {
            id: id
        });
    }

    async getItemData(id: string): Promise<DiscountGroupDocumentRelation> {
        return (await lastValueFrom(await this.getItem(id).mapSingle(x => x.getDiscountGroupDocumentRelation as DiscountGroupDocumentRelation)));
    }

    getItemStream(id: string): Observable<DiscountGroupDocumentRelation> {
        return this.getItem(id).mapStream(x => x.getDiscountGroupDocumentRelation as DiscountGroupDocumentRelation);
    }

    async saveItem(item: DiscountGroupDocumentRelationInput): Promise<DiscountGroupDocumentRelation> {
        // if (!item.type)
        //     item.type = DiscountGroupType.DOCUMENT;

        let validated = await this.systemService.validateObject<DiscountGroupDocumentRelationInput>(item, "DiscountGroupDocumentRelationInput");

        let saved = await lastValueFrom(await this.baseDataService.mutate<SaveDiscountGroupDocumentRelationMutation, SaveDiscountGroupDocumentRelationMutationVariables>(
            SAVE_DISCOUNT_GROUP_DOCUMENT_RELATION, {
            input: validated
        }));
        return saved.saveDiscountGroupDocumentRelation as DiscountGroupDocumentRelation;
    }

    async deleteItem(id: string): Promise<DeletionResponse> {
        let res = await lastValueFrom(await this.baseDataService.mutate<DeleteDiscountGroupDocumentRelationMutation, DeleteDiscountGroupDocumentRelationMutationVariables>(
            DELETE_DISCOUNT_GROUP_DOCUMENT_RELATION, {
            id: id
        }));

        return res.deleteDiscountGroupDocumentRelation;
    }
}